module.exports = __webpack_public_path__ + "img/engagementring.a7d9f3b.png";